import {
  ADD_RECORD_FAIL,
  ADD_RECORD_REQUEST,
  ADD_RECORD_SUCCESS,
  SAVE_FILLED_RECORD,
  RECORD_MINE_LIST_REQUEST,
  RECORD_MINE_LIST_SUCCESS,
  RECORD_MINE_LIST_FAIL,
  RECORD_SUMMARY_REQUEST,
  RECORD_SUMMARY_SUCCESS,
  RECORD_SUMMARY_FAIL,
  ADD_YEARLYREPORT_REQUEST,
  ADD_YEARLYREPORT_SUCCESS,
  ADD_YEARLYREPORT_FAIL,
  SAVE_YEARLYREPORT_RECORD,
  LIST_YEARLYREPORT_REQUEST,
  LIST_YEARLYREPORT_SUCCESS,
  LIST_YEARLYREPORT_FAIL,
  SEARCH_RECORD_REQUEST,
  SEARCH_RECORD_SUCCESS,
  SEARCH_RECORD_FAIL,
  RECORD_CATEGORY_LIST_REQUEST,
  RECORD_CATEGORY_LIST_SUCCESS,
  RECORD_CATEGORY_LIST_FAIL,
  RECORD_DELETE_REQUEST,
  RECORD_DELETE_SUCCESS,
  RECORD_DELETE_FAIL,
  RECORD_DELETE_RESET,
  RECORD_DETAILS_REQUEST,
  RECORD_DETAILS_SUCCESS,
  RECORD_DETAILS_FAIL,
  RECORD_UPDATE_REQUEST,
  RECORD_UPDATE_SUCCESS,
  RECORD_UPDATE_FAIL,
  RECORD_UPDATE_RESET,
  ADD_CATEGORY_FAIL,
  ADD_CATEGORY_REQUEST,
  ADD_CATEGORY_SUCCESS,
  SAVE_FILLED_CATEGORY,
  CATEGORY_DELETE_RESET,
  CATEGORY_DELETE_REQUEST,
  CATEGORY_DELETE_SUCCESS,
  CATEGORY_DELETE_FAIL,
  ADD_TAXRATE_REQUEST,
  ADD_TAXRATE_SUCCESS,
  ADD_TAXRATE_FAIL,
  SAVE_FILLED_TAXRATE,
  RECORD_TAXRATE_LIST_REQUEST,
  RECORD_TAXRATE_LIST_SUCCESS,
  RECORD_TAXRATE_LIST_FAIL,
  TAXRATE_DELETE_REQUEST,
  TAXRATE_DELETE_SUCCESS,
  TAXRATE_DELETE_FAIL,
  TAXRATE_DELETE_RESET,
  TAXRATE_UPDATE_REQUEST,
  TAXRATE_UPDATE_SUCCESS,
  TAXRATE_UPDATE_FAIL,
  ONE_TAXRATE_LIST_REQUEST,
  ONE_TAXRATE_LIST_SUCCESS,
  ONE_TAXRATE_LIST_FAIL,
  TAXRATE_UPDATE_RESET,
} from "../constants/financeConstants";

export const addRecordReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_RECORD_REQUEST:
      return { loading: true };
    case ADD_RECORD_SUCCESS:
      return { loading: false, addFinanceRec: action.payload };
    case ADD_RECORD_FAIL:
      return { loading: false, error: action.payload };
    case SAVE_FILLED_RECORD:
      return { ...state, filledRecord: action.payload };
    default:
      return state;
  }
};

export const recordMineListReducer = (
  state = { loading: true, summary: {} },
  action
) => {
  switch (action.type) {
    case RECORD_MINE_LIST_REQUEST:
      return { loading: true };
    case RECORD_MINE_LIST_SUCCESS:
      return { loading: false, summary: action.payload };
    case RECORD_MINE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const recordSummaryReducer = (
  state = { loading: true, summary: {} },
  action
) => {
  switch (action.type) {
    case RECORD_SUMMARY_REQUEST:
      return { loading: true };
    case RECORD_SUMMARY_SUCCESS:
      return { loading: false, summary: action.payload };
    case RECORD_SUMMARY_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const addYearlyReportReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_YEARLYREPORT_REQUEST:
      return { loading: true };
    case ADD_YEARLYREPORT_SUCCESS:
      return { loading: false, addYearlyReport: action.payload };
    case ADD_YEARLYREPORT_FAIL:
      return { loading: false, error: action.payload };
    case SAVE_YEARLYREPORT_RECORD:
      return { ...state, filledYearlyReport: action.payload };
    default:
      return state;
  }
};

export const listYearlyReportReducer = (
  state = { existedYearlyReportRecords: [] },
  action
) => {
  switch (action.type) {
    case LIST_YEARLYREPORT_REQUEST:
      return { loading: true };
    case LIST_YEARLYREPORT_SUCCESS:
      return { loading: false, existedYearlyReportRecords: action.payload };
    case LIST_YEARLYREPORT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const recordSearchReducer = (
  state = { loading: true, records: [] },
  action
) => {
  switch (action.type) {
    case SEARCH_RECORD_REQUEST:
      return { loading: true };
    case SEARCH_RECORD_SUCCESS:
      return {
        loading: false,
        records: action.payload,
      };
    case SEARCH_RECORD_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const recordCategoryListReducer = (
  state = { loading: true, records: [] },
  action
) => {
  switch (action.type) {
    case RECORD_CATEGORY_LIST_REQUEST:
      return { loading: true };
    case RECORD_CATEGORY_LIST_SUCCESS:
      return { loading: false, summary: action.payload };
    case RECORD_CATEGORY_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
/*
export const listCategoryReducer = (
  state = { loading: true, records: [] },
  action
) => {
  switch (action.type) {
    case RECORD_CATEGORY_LIST_REQUEST:
      return { loading: true };
    case RECORD_CATEGORY_LIST_SUCCESS:
      return { loading: false, summary: action.payload };
    case RECORD_CATEGORY_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
*/
export const recordDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case RECORD_DELETE_REQUEST:
      return { loading: true };
    case RECORD_DELETE_SUCCESS:
      return { loading: false, success: true };
    case RECORD_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case RECORD_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const recordDetailsReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case RECORD_DETAILS_REQUEST:
      return { loading: true };
    case RECORD_DETAILS_SUCCESS:
      return { loading: false, record: action.payload };
    case RECORD_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const recordUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case RECORD_UPDATE_REQUEST:
      return { loading: true };
    case RECORD_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case RECORD_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case RECORD_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const addCategoryReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_CATEGORY_REQUEST:
      return { loading: true };
    case ADD_CATEGORY_SUCCESS:
      return { loading: false, addCategoryRec: action.payload };
    case ADD_CATEGORY_FAIL:
      return { loading: false, error: action.payload };
    case SAVE_FILLED_CATEGORY:
      return { ...state, filledCategory: action.payload };
    default:
      return state;
  }
};

export const categoryDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case CATEGORY_DELETE_REQUEST:
      return { loading: true };
    case CATEGORY_DELETE_SUCCESS:
      return { loading: false, success: true };
    case CATEGORY_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case CATEGORY_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const addTaxrateReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_TAXRATE_REQUEST:
      return { loading: true };
    case ADD_TAXRATE_SUCCESS:
      return { loading: false, addedTaxrateRec: action.payload };
    case ADD_TAXRATE_FAIL:
      return { loading: false, error: action.payload };
    case SAVE_FILLED_TAXRATE:
      return { ...state, filledTaxrate: action.payload };
    default:
      return state;
  }
};

export const taxrateDetailsReducer = (state = { loading: true }, action) => {
  switch (action.type) {
    case ONE_TAXRATE_LIST_REQUEST:
      return { loading: true };
    case ONE_TAXRATE_LIST_SUCCESS:
      return { loading: false, taxrate: action.payload };
    case ONE_TAXRATE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const taxrateDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case TAXRATE_DELETE_REQUEST:
      return { loading: true };
    case TAXRATE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case TAXRATE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case TAXRATE_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

export const recordTaxrateListReducer = (
  state = { loading: true, records: [] },
  action
) => {
  switch (action.type) {
    case RECORD_TAXRATE_LIST_REQUEST:
      return { loading: true };
    case RECORD_TAXRATE_LIST_SUCCESS:
      return { loading: false, summary: action.payload };
    case RECORD_TAXRATE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const taxrateUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case TAXRATE_UPDATE_REQUEST:
      return { loading: true };
    case TAXRATE_UPDATE_SUCCESS:
      return { loading: false, success: true };
    case TAXRATE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case TAXRATE_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};
